export const version = "hdnode/5.5.0";
//# sourceMappingURL=_version.js.map